import { AdminExamLocationRoomPhysicalInfoDetails } from '@exam-center/admin-exam-center-location-details';
import { NavigateBackLinkWithHistory } from '@exam-center/components';
import { useParams } from '@exam-center/router';
import { Box, PageHeader, PaperSection } from '@shared/components';

export default function AdminExamCenterRoomPhysicalInfoPage() {
  const { roomId } = useParams('/admin/exam-location/locations/:roomId/physical-info');

  return (
    <>
      <PageHeader
        title='รายละเอียดข้อมูลลักษณะทางกายภาพ'
        linkAdornment={
          <NavigateBackLinkWithHistory
            fallbackPath='/admin/exam-location/locations/:roomId'
            fallbackParams={{ roomId }}
            label='Back'
          />
        }
      />
      <Box sx={{ p: 6 }}>
        <PaperSection title='ข้อมูลลักษณะทางกายภาพ'>
          <AdminExamLocationRoomPhysicalInfoDetails />
        </PaperSection>
      </Box>
    </>
  );
}
